export default __webpack_public_path__ + "static/media/insta07.8a312b64.webp";